<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>DNS Servers</h4>
      </div>
    </div>
    <div class="row" v-if="[3, 4].includes(logged_in_user.group_id)">
      <div class="col-8">
        <div class="alert alert-warning" role="alert">
          <b>Notice:</b> Updating DNS Servers requires that the machine be restarted to take effect.
        </div>
      </div>
    </div>
    <div class="row" v-if="[3, 4].includes(logged_in_user.group_id)">
      <div class="col-12">
        <router-link :to="{ name:'AdminMachineDNSAdd' }" class="btn btn-success"><i class="fa fa-edit"
                                                                                      aria-hidden="true"></i>
          Add Server
        </router-link>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-8">
        <table class="table table-striped">
          <thead class="bg-hub-primary text-white">
          <tr>
            <th>Server</th>
            <th v-if="[3, 4].includes(logged_in_user.group_id)">Manage</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="dns_server in dns_servers" :key="dns_server.dns_server_id">
            <td>{{ dns_server.address }}</td>
            <td v-if="[3, 4].includes(logged_in_user.group_id)">
              <button type="button" class="btn btn-danger" @click="deleteDNSServer(dns_server)"><i
                class="fa fa-trash fa-fw" aria-hidden="true"></i>Delete
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'network',
  computed: mapGetters({
    dns_servers: 'allDNSServers',
    logged_in_user: 'loggedInUser'
  }),
  methods: mapActions([
    'deleteDNSServer'
  ]),
  created () {
    this.$store.dispatch('getDNSServers')
  }
}
</script>

<style scoped>

</style>
